import { Stack, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { ItemMetadataDetail, Maybe } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type ExhibitionPeriodProps = {
  metadata?: Maybe<ItemMetadataDetail>
}

export const ExhibitionPeriod: Organism<ExhibitionPeriodProps> = ({
  metadata,
}) => {
  const { t } = useTranslation('resaleCreate')
  return (
    <OrganismFrame>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ bgcolor: 'grey.50', py: 2, px: 1 }}
      >
        <Icons.Timer fontSize="small" sx={{ color: 'grey.600' }} />
        <Typography variant="h6" color="text.secondary">
          {t('listingPeriod')}
        </Typography>
      </Stack>
      <Stack spacing={2} sx={{ pt: 3, pb: 7 }}>
        {metadata?.ticket?.resalePeriod && (
          <Typography variant="body2">
            {metadata?.ticket?.resalePeriod?.formattedStartedAt} 〜{' '}
            {metadata?.ticket?.resalePeriod?.formattedEndedAt}
          </Typography>
        )}
        <Typography variant="caption" color="text.secondary">
          {t('listingPeriodNote')}
        </Typography>
      </Stack>
    </OrganismFrame>
  )
}
